import { Link as TiptapLink } from '@tiptap/extension-link'

import { LinkActionButton } from '@/tiptap/extensions/components/ActionButton'
import LinkDialog from './components/link/LinkDialog.vue'

export default TiptapLink.extend({
  addOptions() {
    return {
      ...(this.parent ? this.parent() : {}),
      openOnClick: false,
      dialogComponent: () => LinkDialog,
      button: ({ editor, extension, t }) => {
        const { dialogComponent } = extension.options
        return {
          component: LinkActionButton,
          componentProps: { editor, t },
          componentSlots: {
            dialog: dialogComponent(),
          },
        }
      },
    }
  },
})
